import React from 'react';
import { Img, Icon, Button } from 'components';
import { Section, Box, Text } from 'styles';

export function Section6(props) {

  // issue#12326: make image in section 6 scrollable

  return (
    <Section $backgroundColor="secondary10">
      <Box $maxWidth={1600} $padding="80px 40px" $mPadding="40px 20px" $margin="auto">
        <Box $width="fit-content" $margin="auto">
          <Button $type="badge">
            <Icon name="badgeIcon" />
            AI Report
          </Button>
        </Box>
        <Text $type="b40" $mType="b28" $padding="24px 0 16px" $textAlign="center">
          AI REPORT로 결과를 분석해드립니다
        </Text>
        <Text $type="18" $mType="16" $textAlign="center" $color="gray600">
          설문 데이터를 기반으로 AI가 분석한 결과 리포트를 제공합니다.
        </Text>
        <Box $margin="auto" $width="fit-content" $padding="40px 0 16px" $mPadding="16px 0 8px" $textAlign="center">
          <Img desktopSrc="reportTabs" $width="100%" />
        </Box>
        <Box $margin="auto" $width="fit-content" $padding="16px 40px" $mPadding="8px 20px" $maxWidth={1600}>
          <Box $width="100%" $position="relative" $display="flex">
            <Img desktopSrc="main6" mobileSrc="moMain6" $width="100%" $position="relative"/>
            <Box $position="absolute"
                 $top="5%" $left="12%" $width="76%" $height="78%" $zIndex={0.5} $overflow="auto">
              <Img desktopSrc="main6Content" mobileSrc="moMain6Content" $width="100%"/>
            </Box>
          </Box>
        </Box>
      </Box>
    </Section>
  );
}
